import styled from 'styled-components';

export const BreadcrumbsWrapper = styled.div`
  img {
    width: 16px;
    height: 16px;
    object-fit: contain;
  }

  li > span {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`;
